import { render, staticRenderFns } from "./checkresult.vue?vue&type=template&id=6ce63d2d&scoped=true&"
import script from "./checkresult.vue?vue&type=script&lang=js&"
export * from "./checkresult.vue?vue&type=script&lang=js&"
import style0 from "./checkresult.vue?vue&type=style&index=0&id=6ce63d2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce63d2d",
  null
  
)

export default component.exports